"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestFile = void 0;
var axios_1 = __importDefault(require("axios"));
var element_plus_1 = require("element-plus");
var nporgress_1 = require("./nporgress");
var index_1 = __importDefault(require("@/router/index"));
/* eslint-disable */
// const baseURL = 'http://127.0.0.1:9000' //本地测试环境
var baseURL = 'http://47.93.35.47:9000'; //服务器地址
var service = axios_1.default.create({
    baseURL: baseURL,
    timeout: 5000
});
var loadingInstance = undefined;
service.interceptors.request.use(function (config) {
    if (config && config.headers) {
        (0, nporgress_1.start)();
        loadingInstance = element_plus_1.ElLoading.service({
            lock: true,
            text: '加载中，请稍候...',
            background: 'rgba(0, 0, 0, 0.5)',
        });
        if (localStorage.getItem("token") && localStorage.getItem("token") !== 'undefined') {
            config.headers['token'] = localStorage.getItem("token");
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
service.interceptors.response.use(function (response) {
    var res = response.data;
    (0, nporgress_1.close)();
    if (loadingInstance) {
        loadingInstance.close();
    }
    switch (res.code) {
        case 200:
            return res;
        case 401:
            localStorage.setItem("token", res.data);
            return service(response.config);
            break;
        case 403:
            (0, element_plus_1.ElNotification)({
                message: res.message,
                type: 'error',
                duration: 0
            });
            index_1.default.push({ path: "/login" });
            break;
        default:
            (0, element_plus_1.ElNotification)({
                message: res.message || '请求错误',
                type: 'error',
                duration: 5 * 1000
            });
            break;
    }
}, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        (0, nporgress_1.close)();
        if (loadingInstance) {
            loadingInstance.close();
        }
        if (error.message.includes("timeout")) {
            element_plus_1.ElNotification.error("请求超时，请稍后再试");
        }
        else {
            (0, element_plus_1.ElNotification)({
                message: error.message || '服务器请求错误，请稍后重试',
                type: 'error',
                duration: 5 * 1000
            });
        }
        return [2 /*return*/, Promise.reject(error)];
    });
}); });
// 文件下载通用方式
exports.requestFile = axios_1.default.create({
    baseURL: baseURL,
    timeout: 0, //关闭超时时间
});
exports.requestFile.interceptors.request.use(function (config) {
    config.headers['token'] = localStorage.getItem("token"); //携带的请求头
    config.responseType = 'blob';
    loadingInstance = element_plus_1.ElLoading.service({
        lock: true,
        text: '正在下载，请稍候...',
        background: 'rgba(0, 0, 0, 0.5)',
    });
    return config;
});
exports.requestFile.interceptors.response.use(function (response) {
    var res = response.data;
    var content = response.headers['content-disposition'] || 'filename=下载文件.xlsx';
    var filename = decodeURIComponent(content.split("filename=")[1]);
    if (loadingInstance) {
        loadingInstance.close();
    }
    var blob = new Blob([res], {
        type: response.headers['content-type'] //文件下载类型
    });
    var url = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = filename; // 自定义文件名
    link.click();
    return res;
}, function (err) {
    (0, element_plus_1.ElNotification)({
        message: '操作失败，请联系管理员',
        type: 'error',
    });
    if (loadingInstance) {
        loadingInstance.close();
    }
});
exports.default = service;
